import { render, staticRenderFns } from "./committee.vue?vue&type=template&id=14150931"
import script from "./committee.vue?vue&type=script&lang=js"
export * from "./committee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports